import * as React from "react";
// style, design

import BaseTable from "src/components/Lists/Base/FinalTable/BaseTable";

import columnDefs from "./listDefs";

// store, state
import { buildRangeFilter } from "../../Lists/Base/utils";

import {
  useOtherInvoicingPagination,
  performFilter,
  constants,
  detailUrl,
} from "../../../store/invoicingOther";

export default ({
  persistantQuery,
  isBare,
  ignoreLocalStorage,
  tableId,
  onRowClicked,
  checkRowHighlighted,
  onRowSelected,
}) => {
  const columns = React.useMemo(() => columnDefs(), [persistantQuery]);

  const badges = {};
  const filters = {};

  return (
    <BaseTable
      tableId={tableId || "other_invoicing_full_table"}
      title={"Övriga avtal"}
      onRowClickedWithDetail={(obj) =>
        detailUrl({
          id: obj.other_contract.id,
        })
      }
      {...{
        isBare,
        ignoreLocalStorage,
        onRowClicked,
        columns,
        persistantQuery,
        badges,
        filters,
        constants,
        checkRowHighlighted,
        onRowSelected,
      }}
    />
  );
};
